/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
const clearFormErrors = (form) => {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.login-form-error').empty();
    $(form).find('.login-form-error').removeClass('login-form-error-block');
    $(form)
        .find('.login-form-error-generic')
        .removeClass('login-form-error-block')
        .addClass('hidden');
};

// If ja-JP language set, swap name and last name input form
const swapFirstLastName = () => {
    if ($('meta[http-equiv=content-language]').attr('content') != 'ja-JP') {
        return;
    }

    var firstNameIdList = [
        'shippingFirstName', // 'Checkout' page
        'nameformemail', // 'Send us an e-mail' page
        'registration-form-fname', // 'Register' page
        'billingFirstName', // 'Edit Billing' page
        'firstName', // 'Add Address' page
        'name-frm', // 'Fiscal code calc' modal
    ];

    var lastNameIdList = [
        'shippingLastName',
        'secondnameformemail',
        'registration-form-lname',
        'billingLastName',
        'lastName',
        'surname-frm',
    ];

    for (var i = 0; i < firstNameIdList.length; i++) {
        var firstNameId = firstNameIdList[i];
        var lastNameId = lastNameIdList[i];

        // Skip to next loop if one input doesn't exist
        if (!$('#' + firstNameId).length || !$('#' + lastNameId).length) {
            continue;
        }

        // Check two inputs are next to each other
        if (
            $('#' + firstNameId)
                .parents('.cell')
                .next('.cell')
                .find('#' + lastNameId)
                .length
        ) {
            $('#' + lastNameId)
                .closest('.cell')
                .after($('#' + firstNameId).closest('.cell'));

            // Adjust padding on 'Register' page
            if (i == 2) {
                $('#' + firstNameId)
                    .parents('.register-form-final-padding-right')
                    .removeClass('register-form-final-padding-right')
                    .addClass('register-form-final-padding-left');
                $('#' + lastNameId)
                    .parents('.register-form-final-padding-left')
                    .removeClass('register-form-final-padding-left')
                    .addClass('register-form-final-padding-right');
            }
        }
    }
};

export const addInputClearIcon = (inputItem) => {
    var $inputFieldContainer = $(inputItem).closest(
        '.form-fields-item__label:not(.form-fields-item__label--select)'
    );
    var clearIconTopPos =
        $(inputItem).outerHeight() / 2 +
        ($('.form-fields-item__input-label', $inputFieldContainer).length > 0
            ? $('.form-fields-item__input-label', $inputFieldContainer).outerHeight(true)
            : 0);

    if ($inputFieldContainer.find('.form-fields-item__clearIcon').length === 0) {
        $inputFieldContainer.append('<span class="form-fields-item__clearIcon"></span>');
    }
    $('.form-fields-item__clearIcon', $inputFieldContainer).css('top', clearIconTopPos);

    if (inputItem.value !== '') {
        $(inputItem).addClass('cc-isPrefilled');
    }

    $(inputItem)
        .on('focus', function () {
            $inputFieldContainer.addClass('focused');
            $(this).removeClass('cc-isPrefilled');
        })
        .on('blur', function () {
            $inputFieldContainer.removeClass('focused');
        });
};
class FormHelpers {
    init(formElement, payload) {
        // clear form validation first
        clearFormErrors(formElement);
        $('.alert', formElement).remove();

        // Chosen select
        if (Foundation.MediaQuery.atLeast('medium')) {
            const selects = $('select.chosen, select.custom-select');
            selects.chosen({ disable_search: true });
            selects.each(function () {
                const ariaLabel = $(this).attr('aria-label');
                
                $(this).next('.chosen-container')
                    .find('.chosen-search-input')
                    .attr('aria-label', ariaLabel);
            });
        }

        if (typeof payload === 'object' && payload.fields) {
            Object.keys(payload.fields).forEach(function (key) {
                if (payload.fields[key]) {
                    var feedbackElement = $(formElement)
                        .find('[name="' + key + '"]')
                        .parent()
                        .children('.invalid-feedback');

                    if (feedbackElement.length > 0) {
                        if (Array.isArray(payload[key])) {
                            feedbackElement.html(payload.fields[key].join('<br/>'));
                        } else {
                            feedbackElement.html(payload.fields[key]);
                        }
                        feedbackElement.siblings('.form-control').addClass('is-invalid');
                        feedbackElement.show();
                    }
                }
            });
        }
        if (payload && payload.error) {
            $(formElement).find('.login-form-error').html(payload.error.join('<br/>'));
            $(formElement).find('.login-form-error').addClass('login-form-error-block');
        }

        $('input[type=text], input[type=email], input[type=number]').each(function (index, inputItem) {
            if ($(inputItem).attr('name') !== 'q') {
                addInputClearIcon(inputItem);
            }
        });

        $('.form-fields-item__clearIcon').on('click touchstart', function (e) {
            $(e.currentTarget).siblings('.form-fields-item__input-field').val('');
        });

        swapFirstLastName();
    }

    /**
     * Display error messages and highlight form fields with errors.
     * @param {string} parentSelector - the form which contains the fields
     * @param {Object} fieldErrors - the fields with errors
     */
    loadFormErrors(parentSelector, fieldErrors) {
        // eslint-disable-line
        // Display error messages and highlight form fields with errors.
        $.each(fieldErrors, (attr) => {
            $('*[name=' + attr + ']', parentSelector)
                .addClass('is-invalid')
                .siblings('.invalid-feedback')
                .html(fieldErrors[attr])
                .show();
        });
        if (fieldErrors.length) {
            $(`*[name=${fieldErrors[0]}]`).trigger('focus');
        }
    }

    /**
     * Clear the form errors.
     * @param {string} parentSelector - the parent form selector.
     */
    clearPreviousErrors(parentSelector) {
        $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
        $('.error-message').hide();
    }

    handleAmexNumber(cardFieldSelector, cardTypeSelector) {
        var cleave = new Cleave(cardFieldSelector, {
            creditCard: true,
            onCreditCardTypeChanged: (type) => {
                const creditCardTypes = {
                    amex: 'Amex',
                };

                const cardType =
                    creditCardTypes[
                        Object.keys(creditCardTypes).indexOf(type) > -1 ? type : 'unknown'
                    ];
                $(cardTypeSelector).val(cardType);
                $('.card-number-wrapper').attr('data-type', type);
                if (type === 'visa' || type === 'mastercard' || type === 'discover') {
                    $('#securityCode').attr('maxlength', 3);
                } else {
                    $('#securityCode').attr('maxlength', 4);
                }
            },
        });

        $(cardFieldSelector).data('cleave', cleave);
    }
    handleCreditCardNumber(cardFieldSelector, cardTypeSelector) {
        var cleave = new Cleave(cardFieldSelector, {
            creditCard: true,
            onCreditCardTypeChanged: (type) => {
                const creditCardTypes = {
                    visa: 'Visa',
                    mastercard: 'Master Card',
                    amex: 'Amex',
                    discover: 'Discover',
                    jcb: 'jcb',
                    diners: 'diners',
                    unknown: 'Unknown',
                };

                const cardType =
                    creditCardTypes[
                        Object.keys(creditCardTypes).indexOf(type) > -1 ? type : 'unknown'
                    ];
                $(cardTypeSelector).val(cardType);
                $('.card-number-wrapper').attr('data-type', type);
                if (type === 'visa' || type === 'mastercard' || type === 'discover') {
                    $('#securityCode').attr('maxlength', 3);
                } else {
                    $('#securityCode').attr('maxlength', 4);
                }
            },
        });

        $(cardFieldSelector).data('cleave', cleave);
    }

    serializeData(form, wasAmexSelected) {
        const serializedArray = form.serializeArray();

        serializedArray.forEach((item) => {
            if (item.name.indexOf('cardNumber') > -1) {
                if (wasAmexSelected === true) {
                    item.value = $('#cardNumberAmex').data('cleave').getRawValue(); // eslint-disable-line
                } else {
                    item.value = $('#cardNumber').data('cleave').getRawValue(); // eslint-disable-line
                }
            }
        });

        return $.param(serializedArray);
    }
}

const formHelpers = new FormHelpers();
export default formHelpers;
